import React, { useState, useEffect, useRef } from "react";
import gsap from "gsap";
import "./HeroSection.css";
import Logo from "../../../Components/Logo/Logo";
import { Link } from "react-router-dom";
import { useGSAP } from "@gsap/react";
import Header from "../../../Components/Header/Header";
import { TypeAnimation } from "react-type-animation";
import SeoHelmet from "../../../Components/SeoHelmet";
import { useTranslation } from "react-i18next";

const HeroTitle = () => {
  const { t, i18n } = useTranslation();
  const [titleKey, setTitleKey] = useState(0);

  useEffect(() => {
    const handleLanguageChange = () => {
      setTitleKey(prev => prev + 1);
    };
    i18n.on("languageChanged", handleLanguageChange);
    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, [i18n]);

  return (
    <TypeAnimation
      key={titleKey}
      sequence={[t("One Team, All Services"), 1000]}
      wrapper="h1"
      speed={40}
      repeat={Infinity}
    />
  );
};

const HeroSection = () => {
  const { t } = useTranslation();
  const [coords1, setCoords1] = useState({ x: 10, y: 0 });
  const [coords2, setCoords2] = useState({ x: 10, y: 0 });

  const paragraphRef = useRef(null);
  const link1Ref = useRef(null);
  const link2Ref = useRef(null);

  const handleMouseMove1 = (e) => {
    const rect = e.target.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    setCoords1({ x, y });
  };

  const handleMouseMove2 = (e) => {
    const rect = e.target.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    setCoords2({ x, y });
  };

  useGSAP(() => {
    gsap.from(paragraphRef.current, {
      opacity: 0,
      x: 100,
      duration: 1.5,
      delay: 1.5,
      ease: "power3.out",
    });
    gsap.from(link1Ref.current, {
      opacity: 0,
      y: 50,
      duration: 1.5,
      delay: 1.5,
      ease: "power3.out",
    });
    gsap.from(link2Ref.current, {
      opacity: 0,
      y: 50,
      duration: 1.5,
      delay: 1.5,
      ease: "power3.out",
    });
  }, []);

  return (
    <div className="HeroSection">
      <Header />
      <SeoHelmet
        title="SunMed | Home"
        description="SunMed: One Team with All Services under one roof — media production, social media, design, events, and web — all flowing from a unified creative vision.."
        keywords="SunMed, media production, web solutions, digital marketing, education, event management"
        url="https://sunmed.com"
        image="https://sunmed.com/images/sunmed-home-og.jpg"
      />
      <div className="content">
        <HeroTitle />
        <p ref={paragraphRef} className="max-w-[650px]">
      
            This website is owned and operated by SUN G for Investment, Advertising Services and Industries, the legal owner of the brand “SunMed Agency”. Commercial Registration No.: 235112
            <br />
            هذا الموقع مملوك ويتبع شركة اس يو ان جي للاستثمار والخدمات الإعلانية والصناعات (ش.ذ.م.م)،المالكة للعلامة التجارية SunMed Agency. السجل التجاري رقم: 235112
      
          {/* {t("Your brand deserves a partner that combines creative power wit digital, marketing & learning expertise.")} */}
        </p>
        <div className="flex justify-center items-center gap-7 flex-col md:flex-row mt-3 md:mt-0">
          <Link
            ref={link1Ref}
            onMouseMove={handleMouseMove1}
            style={{
              backgroundImage: `radial-gradient(circle at ${coords1.x}px ${coords1.y}px, rgba(255,255,255,0.4), rgba(0,0,0,0) 40%)`,
            }}
            className="link"
          >
            {t("Free consultation")}
          </Link>
          <a
            href="#with"
            ref={link2Ref}
            onMouseMove={handleMouseMove2}
            style={{
              backgroundImage: `radial-gradient(circle at ${coords2.x}px ${coords2.y}px, rgba(255,255,255,0.4), rgba(0,0,0,0) 40%)`,
            }}
            className="link"
          >
            {t("Start project")}
          </a>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;


